export const SkillsData = [
    {
        type: "Frontend",
        list: [
            {
                name: "ReactJS",
                icon: <i className="devicon-react-original colored"></i>
            },
            {
                name: "Javascript",
                icon: <i className="devicon-javascript-plain colored"></i>
            },
            {
                name: "Angular",
                icon: <i className="devicon-angularjs-plain colored"></i>
            },
            {
                name: "Typescript",
                icon: <i className="devicon-typescript-plain colored"></i>
            },
        ]
    },
    {
        type: "Backend",
        list: [
            {
                name: "NodeJS",
                icon: <i className="devicon-nodejs-plain colored"></i>   
            },
            {
                name: "PHP",
                icon: <i className="devicon-php-plain colored"></i>   
            },
            {
                name: "Firebase",
                icon: <i className="devicon-firebase-plain colored"></i>   
            },
            {
                name: "Laravel",
                icon: <i className="devicon-laravel-plain colored"></i>   
            },
        ]
    },
    {
        type: "Databases and cloud hosting",
        list: [
            {
                name: "GitHub Pages",
                icon: <i className="devicon-github-original"></i>   
            },
            {
                name: "Heroku",
                icon: <i className="devicon-heroku-original colored"></i>   
            },
            {
                name: "MongoDB",
                icon: <i className="devicon-mongodb-plain colored"></i>   
            },
            {
                name: "MySQL",
                icon: <i className="devicon-mysql-plain colored"></i>   
            },
            {
                name: "Oracle",
                icon: <i className="devicon-oracle-original colored"></i>   
            },
        ]
    },

]